import { memo, useMemo } from 'react';

import { IconButton } from '@atlaskit/button/new';
import DeleteIcon from '@atlaskit/icon/core/delete';
import Tooltip from '@atlaskit/tooltip';

import { Account, Repository } from 'src/components/pipelines/models';
import {
  formatDate,
  formatDistanceToNow,
} from 'src/components/pipelines/utils';

import { getPipelinePageURL } from '../utils/links';

import BitbucketLink from './BitbucketLink';
import { CacheItem } from './Caches';
import {
  SmartCacheRemoveButton,
  SmartCachesFileSize,
  SmartCachesVersionName,
  SmartCachesVersionWrapper,
} from './styled';

type Props = {
  account: Account;
  repository: Repository;
  onClickRemove: (item: CacheItem) => void;
  item: CacheItem;
};

const CacheVersionRow = ({
  account,
  repository,
  onClickRemove,
  item,
}: Props) => {
  const pipelinePageUrl = useMemo(
    () => getPipelinePageURL({ uuid: item.pipelineUuid }, repository.path),
    [item.pipelineUuid, repository.path]
  );
  return (
    <SmartCachesVersionWrapper role="row">
      <SmartCachesVersionName role="gridcell">
        <BitbucketLink
          account={account}
          repository={repository}
          to={pipelinePageUrl}
        >
          {item.label}
        </BitbucketLink>
      </SmartCachesVersionName>
      <SmartCachesFileSize role="gridcell">
        {item.fileSize!}
      </SmartCachesFileSize>
      <div role="gridcell">
        <Tooltip content={formatDate(item.createdOn!)}>
          <span>{formatDistanceToNow(item.createdOn!)}</span>
        </Tooltip>
      </div>
      {repository.canWrite && (
        <SmartCacheRemoveButton role="gridcell">
          <Tooltip content="Delete cache version" position="top">
            <IconButton
              label="Remove"
              appearance="subtle"
              icon={DeleteIcon}
              onClick={() => onClickRemove(item)}
            />
          </Tooltip>
        </SmartCacheRemoveButton>
      )}
    </SmartCachesVersionWrapper>
  );
};

// eslint-disable-next-line import/no-default-export
export default memo(CacheVersionRow);
